import { PropsWithChildren } from 'react';

import { useResponsive } from '../lib';

export const Desktop = ({ children }: PropsWithChildren) => {
  const { isDesktop } = useResponsive();
  return isDesktop ? children : null;
};
export const Mobile = ({ children }: PropsWithChildren) => {
  const { isMobile } = useResponsive();
  return isMobile ? children : null;
};
